import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import OptionsInput from '../../../base/OptionsInput';
import InputsField from '../../../base/InputsField';
import Styles from '../CommentsForm.styles';

const FieldGroup = styled.div`${Styles.fieldGroup}`; // prettier-ignore

const INPUT_BASE_STYLE = { background: '#FEFEFE', borderRadius: 5, height: 40, fontSize: 14, paddingLeft: 16, paddingRight: 16, border: 'none' }

/**
 * Create the form component
 * @param  {any} props componente properties
 * @returns {JSX}
 */
const Form = (props) => {
  const {
    data,
    translations,
    handleChange,
    areaHandler,
    handleSubmit,
    disableButton,
    label,
  } = props;
  const {
    name,
    surnames,
    postalcode,
    email,
    subject,
    comment,
    subjectOptions
  } = data;

  const onSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    handleSubmit();
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-5 ">
          <InputsField
            placeHolder={`${translations.name}`}
            label={`${translations.name}`}
            value={name.value}
            onChange={handleChange}
            name="name"
            status={name.status}
            isRequired
            labelPosition="top"
            style={INPUT_BASE_STYLE}
          />
        </div>
        <div className="col-xs-12 col-sm-6 offset-md-1">
          <InputsField
            placeHolder={`${translations.surnames}`}
            label={translations.surnames}
            value={surnames.value}
            name="surnames"
            status={surnames.status}
            isRequired
            labelPosition="top"
            style={INPUT_BASE_STYLE}
            onChange={handleChange}
          />
        </div>
        <div className="col-xs-12 col-sm-5">
          <InputsField
            placeHolder={`${translations.postalcode}`}
            label={translations.postalcode}
            value={postalcode.value}
            name="postalcode"
            status={postalcode.status}
            labelPosition="top"
            style={INPUT_BASE_STYLE}
            onChange={handleChange}
          />
        </div>
        <div className="col-xs-12 col-sm-6 offset-md-1">
          <InputsField
            placeHolder={`${translations.email}`}
            label={translations.email}
            value={email.value}
            name="email"
            status={email.status}
            labelPosition="top"
            style={INPUT_BASE_STYLE}
            onChange={handleChange}
          />
        </div>
        <div className="col-xs-12 col-sm-5">
          <OptionsInput
            onChange={areaHandler}
            options={subjectOptions}
            value={subject.value}
            name={translations.subject}
            hasBlackTheme
            labelPosition="top"
            style={INPUT_BASE_STYLE}
          />
        </div>
        <div className="col-xs-12 col-sm-12">
          <InputsField
            type="area"
            label={translations.question_label}
            value={comment.value}
            name="comment"
            status={comment.status}
            labelPosition="top"
            style={{ ...INPUT_BASE_STYLE, width: '100%', height: 98, maxHeight: 98, paddingTop: 8, paddingBottom: 8 }}
            onChange={handleChange}
          />

          <FieldGroup>
            <button id={label /** For Analytics purposes */} disabled={disableButton} style={{ width: 'fit-content', height: 52, paddingLeft: 64, paddingRight: 64, backgroundColor: '#DE69A1', color: '#FCFCFC', outline: 'none', border: 'none', borderRadius: 5, opacity: disableButton ? 0.7 : 1, cursor: disableButton ? 'default' : 'pointer' }} onClick={onSubmit}>{translations.send}</button>
          </FieldGroup>
        </div>
      </div>
    </div>
  );
};
Form.propTypes = {
  data: PropTypes.object,
  translations: PropTypes.object,
  handleChange: PropTypes.func,
  areaHandler: PropTypes.func,
  handleSubmit: PropTypes.func,
  disableButton: PropTypes.bool,
  label: PropTypes.string,
};

export default Form;
